import { createContext } from "react";

// Define a context for the main element
export const MainContext = createContext<any>(null);
export const MasterAdminDashboardContext = createContext<any>(null);
export const RootAdminDashboardContext = createContext<any>(null);
export const LessonsContext = createContext<any>(null);
export const EditorContext = createContext<any>(null);
export const EditorLeftPaneContext = createContext<any>(null);
export const ViewHeaderContext = createContext<any>(null);
export const ExternalEditorContext = createContext<any>(null);
export const CodeEditorContext = createContext<any>(null);
export const PlatformContext = createContext<any>(null);
export const RootContext = createContext<any>(null);
export const PDFDraggablePanelContext = createContext<any>(null);
export const PythonJSEnvironmentContext = createContext<any>(null);
export const ScratchEnvironmentContext = createContext<any>(null);
export const ValidateLessonContentsPopUpContext = createContext<any>(null);
export const CreateEditLessonContext = createContext<any>(null);
export const CreateEditInstructionsContext = createContext<any>(null);
